export default __webpack_public_path__ + "static/media/etavastaanotto-white.96435de3.svg";